<template>
    <van-dialog
        v-model="show"
        title="提示"
        :show-cancel-button="false"
        :show-confirm-button="false">
            <template>
                <van-cell
                    v-for="(item, index) in list"
                    :key="index + item"
                    :border="false"
                    :center="true"
                    :value="item"
                    value-class="text-center"
                >
                </van-cell>
                <button type="button" class="dialog-btn" @click.stop="show = false">我知道了</button>
            </template>
    </van-dialog>
</template>

<script>
    export default {
        name: "GQuestionDescription",
        props: ['list', 'value'],
        computed: {
            show: {
                get() {
                    return this.value
                },
                set() {
                    this.$emit('input', false)
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .text-center {
        text-align: center;
        color: #777;
    }
    .pop-text-title {
        text-align: center;
        margin: 30px 0 12px;
        font-size: 17px;
        font-weight: 500;
        color: #14161A;
        line-height: 24px;
    }

    .pop-text-close {
        border-top: 1px solid #f5f5f5;
        text-align: center;
        margin-top: 40px;
        padding: 18px 0 30px;
        font-size: 17px;
        font-weight: 500;
        color: #14161A;
        line-height: 24px;
    }

    .dialog-btn {
        width: 100%;
        padding: 15px 0;
        border: none;
        border-top: 1px solid #f5f5f5;
        display: block;
        color: #005fe9;
        background: none;
        outline: none;
    }
</style>